/**
 * Created by Bob.Bao on 2017/12/18.
 */
import apis from '../apis'
import * as types from '../mutation-types'
// import _ from 'lodash'
const state = {
    account: {
        'fnameL2': '', // 公司名称
        'fcallname': '', // 大华业务对接人姓名
        'floginnum': '', // 登录名称
        'fpassword': '',
        'fphone': '',
        'smsCode': '',
        'personInChangeNo': '', // 大华业务对接人身份证
        'fsuppliertypeid': '', // 公司类型
        'fbuilddate': '', // 成立日期
        'fenterprisemaster': '', // 法人代表
        'fbusinessnum': '', // 统一社会信用代码
        'fprovinceid': '',
        'fcityid': '',
        'isEngineer': '0',
        'cfcompanyaddres': '', // 公司注册地址
        'faddress': '', // 公司办公地址
        'flinkphone': '', // 公司电话
        'fpostnumber': '', // 邮政编码
        'ftaxpayertype': '', // 纳税人身份
        'fregistermoney': '', // 注册资金
        'fcurrency': '',
        'fenterprisemasterid': '', // 法人代表身份证
        'fcentraltaxno': '', // 国税登记号
        'flandtaxno': '', // 地税登记号
        'fbankname': '', // 开户银行
        'fbankcount': '', // 银行帐号
        'fbankaddress' : '' // 开户银行地址
    },
    'linkpersons': [],
    'serviceas': [], // 服务区域
    'spss': [], // 专业类别]
    bankInfo: [], // 银行信息
    regForm: {},
    user: {
        createDate: '',
        fauthority: '',
        fcallname: '',
        femail: '',
        ffaxnum: '',
        fid: '',
        fisresetpsd: 0,
        fisuser: 1,
        floginnum: '',
        fpassword: '',
        fphone: '',
        ftelphone: '',
        fusersupplier: '',
        id: '',
        isNewRecord: false,
        personInChangeNo: '',
        remarks: '',
        updateDate: ''
    },
    basic: {
        'farParent': '', // 用于“公司类型”，提交的时候要去掉
        'fnameL2': '', // 公司名称
        'fnameen': '', // 公司英文名称
        'fphone': '',
        'fsuppliertypeid': '', // 公司类型
        'fbuilddate': '', // 成立日期
        'fenterprisemaster': '', // 法人代表
        'fenterprisemasterid': '', // 法人代表身份证
        'fcentraltaxno': '', // 国税号
        'flandtaxno': '', // 地税号
        'fbusinessnum': '', // 统一社会信用代码
        'fprovinceid': '',
        'fcityid': '',
        'fbizregdate': '', // 工商注册日期
        'cfcompanyaddres': '', // 公司注册地址
        'faddress': '', // 公司办公地址
        'flinkphone': '', // 公司电话
        'flinkfax': '', // 公司传真
        'fwebsite': '', // 公司网址
        'flinkmail': '', // 公司邮箱
        'fpostnumber': '', // 邮政编码
        'ftaxpayertype': '', // 纳税人身份
        'fregistermoney': '', // 注册资金
        'fbankcount': '', // 银行账户
        'fbankname': '', // 开户银行
        'fbankaddress': '', // 开户银行地址
        'fcurrency': '',
        fcallname: '',
        personInChangeNo: ''
    },
    other: {
        stockId: '',
        fregistermoney: '', // 注册资金
        fenterprisekind: '', // 企业性质
        fdescriptionL2: '', // 简介及业务范围？
        flastfyearprj: '', // 过去五年承接的项目
        // fcurrprj:'',//
        yearsales: [],
        achievements: [],
        aptitudefiles: []
    },
    audits: [],
    managers: [],
    regStep: 0,
    auditStep: 1,
    linkstosps: [],
    gysfjs: [],
    isShowBasic:false,
    hasYrz:true
}
const getters = {
    regStep: state => state.regStep,
    regForm: state => state.regForm,
    account: state => state.account,
    linkpersons: state => state.linkpersons,
    serviceas: state => state.serviceas,
    managers: state => state.managers,
    spss: state => state.spss,
    linkstosps: state => state.linkstosps,
    user: state => state.user,
    basic: state => state.basic,
    other: state => state.other,
    yearsales: state => state.other.yearsales,
    achievements: state => state.other.achievements,
    aptitudefiles: state => state.other.aptitudefiles,
    audits: state => state.audits,
    auditStep: state => state.auditStep,
    gysfjs: state => state.gysfjs,
    bankInfo: state => state.bankInfo,
    isShowBasic: state => state.isShowBasic,
    hasYrz: state => state.hasYrz
}

const actions = {
    removeCaches ({ commit, state }) {
        commit(types.FETCH_CONTACTS, [])
        commit(types.FETCH_SERVICEAS, [])
    },
    getStockStep ({commit, state}) {
        return apis.getStockStep(state.basic.id)
    },
    submitAccount ({ commit, state }) {
        // apis.submitLogin(state.account, account => {

        commit(types.ACCOUNT_FORM, state.account)
        if (state.linkpersons.length) {
            commit(types.EDIT_CONTACT, {
                'editIndex': 0,
                'contact': {
                    'fpersonname': state.account.fcallname,
                    'idCard': state.account.personInChangeNo,
                    'personType': '0',
                    'fposition': '',
                    'fphone': state.account.fphone,
                    'fworkphone': '',
                    'femail': state.account.femail
                }
            })
        } else {
            commit(types.ADD_CONTACT, {
                'contact': {
                    'fpersonname': state.account.fcallname,
                    'idCard': state.account.personInChangeNo,
                    'personType': '0',
                    'fposition': '',
                    'fphone': state.account.fphone,
                    'fworkphone': '',
                    'femail': state.account.femail
                }
            })
        }

        // }, err => {
        //    this.$alert(err)
        // })
    },
    submitRegister ({ commit, state }, cb) {
        commit(types.MAKE_REG_FORM)
        apis.submitRegister(state.regForm, cb.cb, cb.ecb)
    },
    updateSUserStock ({ commit, state }, payload) {
        let data = __pickUpFields(['id', 'fnameL2', 'fnameen', 'fsuppliertypeid', 'fbuilddate', 'fenterprisemaster', 'fenterprisemasterid',
            'flandtaxno', 'fcentraltaxno', 'fbusinessnum', 'fprovinceid', 'fcityid', 'fbizregdate', 'cfcompanyaddres',
            'faddress', 'flinkphone', 'flinkfax', 'fwebsite', 'flinkmail', 'fpostnumber', 'ftaxpayertype',
            'fbankname', 'fbankcount', 'fbankaddress'], state.basic)
        return apis.updateSUserStock(data).then(payload.success, payload.error)
    },
    addOrEditSales ({ commit }, payload) {
        commit(isNaN(payload.editIndex) ? types.ADD_SALES : types.EDIT_SALES, payload)
    },
    addOrEditGysf ({ commit }, payload) {
        commit(types.ADD_GYSF, payload)
    },
    removeSales ({ commit }, payload) {
        commit(types.REMOVE_SALES, payload.editIndex)
    },
    addOrEditAchieve ({ commit }, payload) {
        commit(isNaN(payload.editIndex) ? types.ADD_ACHIEVE : types.EDIT_ACHIEVE, payload)
    },
    removeAchieve ({ commit }, payload) {
        commit(types.REMOVE_ACHIEVE, payload)
    },
    addOrEditApt ({ commit }, payload) {
        commit(isNaN(payload.editIndex) ? types.ADD_APTITUDE : types.EDIT_APTITUDE, payload)
    },
    removeApt ({ commit, state }, payload) {
        commit(types.REMOVE_APTITUDE, payload)
    },
    addOrEditContact ({ commit, state }, payload) {
        // let index = payload.editIndex,
        //    contact = payload.contact,
        //    fparentid = state.basic.id
        // if(fparentid){
        //    let data = __pickUpFields(['fpersonname','fworkphone','fposition','fphone','femail','remark','personType'],contact)
            // if(isNaN(index)){
                // data.fparentid = fparentid
                // apis.addLinkPerson(data).then(payload.success,payload.error)
            // }else{
                // data.id = contact.id
                // apis.editLinkPerson(data).then(payload.success,payload.error)
            // }
        // }else{
        commit(isNaN(payload.editIndex) ? types.ADD_CONTACT : types.EDIT_CONTACT, payload)
        // }
    },
    removeContact ({ commit, state }, payload) {
        // let fparentid = state.basic.id
        // if(fparentid){
        //    apis.deleteLinkPerson(payload.index).then(payload.success,payload.error)
        // }else{
        commit(types.REMOVE_CONTACT, payload)
        // }
    },
    checkDelManager ({ commit, state }, id) { // 删除项目经理验证
        return apis.checkDelManager({id: id})
    },
    addOrEditCategory ({ commit }, payload) {
        // let index = payload.editIndex,
        //    category = payload.category,
        //    fparentid = state.basic.id
        // if(fparentid){
        //    let data = __pickUpFields(['cfservicetypeid','cfremak'],category)
        //    if(isNaN(index)){
        //        data.fparentid = fparentid
        //        data.cfcellpeopleid = category.cfcellpeopleid
        //        data.fpersonname = category.fpersonname
        //        //apis.addSps(data).then(payload.success,payload.error)
        //        payload.success()
        //    }else{
        //        data.id = category.id
        //        //apis.editSps(data).then(payload.success,payload.error)
        //        payload.success()
        //    }
        // }else{
        commit(isNaN(payload.editIndex) ? types.ADD_CATEGORY : types.EDIT_CATEGORY, payload)
        // }
    },
    removeCategory ({ commit, state }, payload) {
        // if(state.basic.id){
        //    apis.deleteSps(payload.editIndex).then(payload.success,payload.error)
        // }else{
        commit(types.REMOVE_CATEGORY, payload)
        // }
    },
    addOrEditArea ({ commit }, payload) {
        // let index = payload.editIndex,
        //    area = payload.area,
        //    fparentid = state.basic.id
        // if(fparentid){
        //    let data = __pickUpFields(['cfprovinceid','cfcityid','cfremark'],area)
        //    if(isNaN(index)){
        //        data.fparentid = fparentid
        //        apis.addServicea(data)
        //            .then(payload.success,payload.error)
        //    }else{
        //        data.id = area.id
        //        apis.editServicea(data)
        //            .then(payload.success,payload.error)
        //    }
        // }else{
        commit(isNaN(payload.editIndex) ? types.ADD_SERVICE_AREA : types.EDIT_SERVICE_AREA, payload)
        // }
    },
    removeArea ({ commit, state }, payload) {
        // let fparentid = state.basic.id
        // if(fparentid){
        //    apis.deleteServicea(payload.editIndex).then(payload.success,payload.error)
        // }else{
        commit(types.REMOVE_SERVICE_AREA, payload)
        // }
    },
    addOrEditManager ({ commit }, payload) {
        // let index = payload.editIndex,
        //    manager = payload.manager,
        //    fparentid = state.basic.id
        // if(fparentid){
        //    let data = __pickUpFields(['name','officeTel','mobile',
        //        'email', 'achievement', 'major', 'grade', 'certificateNo'],manager)
        //    if(isNaN(index)){
        //        data.fparentid = fparentid
        //        apis.addManager(data)
        //            .then(payload.success,payload.error)
        //    }else{
        //        data.id = manager.id
        //        apis.editManager(data)
        //            .then(payload.success,payload.error)
        //    }
        // }else{
        commit(isNaN(payload.editIndex) ? types.ADD_MANAGER : types.EDIT_MANAGER, payload)
        // }
    },
    removeManager ({ commit, state }, payload) {
        // let fparentid = state.basic.id
        // if(fparentid){
        //    apis.deleteManager(state.managers[payload.editIndex].id).then(payload.success,payload.error)
        // }else{
        commit(types.REMOVE_MANAGER, payload)
        // }
    },
    goStep ({ commit }, step) {
        commit(types.REG_STEP, step)
    },
    getLinkPersons ({ commit, state }) {
        return apis.getLinkPersons(state.basic.id).then((res) => {
            if (res.data.result) {
                commit(types.FETCH_CONTACTS, res.data.value)
            } else {
                this.$alert(res.data.message)
            }
        }, err => {
            this.$alert(err)
        })
    },
    getManagers ({ commit, state }) {
        return apis.getManagers(state.basic.id).then(res => {
            if (res.data.result) {
                commit(types.FETCH_MANAGERS, res.data.value)
            } else {
                this.$alert(res.data.message)
            }
        }, err => {
            this.$alert(err)
        })
    },
    getGysfjs ({ commit, state }) {
        return apis.getGysfjs(state.basic.id).then(res => {
            if (res.data.result) {
                commit(types.FETCH_GYSFJS, res.data.value)
            } else {
                this.$alert(res.data.message)
            }
        }, err => {
            this.$alert(err)
        })
    },
    getServiceas ({ commit, state }) {
        return apis.getServiceas(state.basic.id).then((res) => {
            if (res.data.result) {
                commit(types.FETCH_SERVICEAS, res.data.value.map(a => {
                    return {
                        cfprovinceid: a.provinceFid,
                        cfcityid: a.cityFid,
                        cfremark: a.cfremark,
                        province: a.provinceName,
                        city: a.cityName,
                        id: a.id
                    }
                }))
            } else {
                this.$alert(res.data.message)
            }
        }, err => {
            this.$alert(err)
        })
    },
    getSpss ({ commit, state }) {
        return apis.getSpss(state.basic.id).then((res) => {
            if (res.data.result) {
                commit(types.FETCH_SPSS, res.data.value)
            } else {
                this.$alert(res.data.message)
            }
        }, err => {
            this.$alert(err)
        })
    },
    getLinksToSps ({ commit, state }) {
        return apis.getLinksToSps(state.basic.id).then((res) => {
            if (res.data.result) {
                commit(types.FETCH_LinksToSps, res.data.value)
            } else {
                this.$alert(res.data.message)
            }
        }, err => {
            this.$alert(err)
        })
    },
    getStockInfo ({ commit, state }) {
        return apis.getStockInfo(state.basic.id).then((res) => {
            if (res.data.result) {
                let data = res.data.value
                data.supplierStockInfo.farParent = data.farParent
                commit(types.FETCH_STOCK_INFO, data)
            } else {
                this.$alert(res.data.message)
            }
        }, err => {
            this.$alert(err)
        })
    },
    getOtherInfo ({ commit, state }) {
        return apis.getOtherInfo(state.basic.id).then((res) => {
            if (res.data.result) {
                commit(types.FETCH_OTHER_INFO, res.data.value)
            } else {
                this.$alert(res.data.message)
            }
        }, err => {
            this.$alert(err)
        })
    },
    editOtherInfo ({ commit, state }, payload) {
        state.other.stockId = state.basic.id
        let data = Object.assign({}, state.other)
        data.achievements.forEach(a => {
            a.baseFiles = a.baseFiles.map(f => {
                return __pickUpFields(['fileName', 'fileOldName', 'filePath', 'fileSize', 'fileType', 'sort'], f)
            })
        })
        data.aptitudefiles.forEach(a => {
            a.baseFiles = a.baseFiles.map(f => {
                return __pickUpFields(['fileName', 'fileOldName', 'filePath', 'fileSize', 'fileType', 'sort'], f)
            })
        })

        return apis.editOtherInfo(data).then(payload.success, payload.error)
    },
    getAuditRes ({ commit, state }) {
        let data = {
            stockId: state.basic.id
        }
        return apis.getAuditRes(data).then((res) => {
            if (res.data.result) {
                commit(types.FETCH_AUDIT_INFO, res.data.value)
            } else {
                this.$alert(res.data.message)
            }
        }, err => {
            this.$alert(err)
        })
    },
    checkSUserStock ({ commit, state }, payload) {
        let data = __pickUpFields(['id', 'fnameL2', 'fnameen', 'fsuppliertypeid', 'fbuilddate', 'fenterprisemaster', 'fenterprisemasterid',
            'flandtaxno', 'fcentraltaxno', 'fbusinessnum', 'fprovinceid', 'fcityid', 'fbizregdate', 'cfcompanyaddres',
            'faddress', 'flinkphone', 'flinkfax', 'fwebsite', 'flinkmail', 'fpostnumber', 'ftaxpayertype',
            'fbankname', 'fbankcount', 'fbankaddress'], state.basic)
        return apis.checkSUserStock(data).then(payload.success, payload.error)
    },
    checkOtherInfo ({ commit, state }, payload) {
        state.other.stockId = state.basic.id
        let data = JSON.parse(JSON.stringify(state.other))
        data.achievements.forEach(a => {
            a.baseFiles = a.baseFiles.map(f => {
                return __pickUpFields(['fileName', 'fileOldName', 'filePath', 'fileSize', 'fileType', 'sort'], f)
            })
        })
        data.aptitudefiles.forEach(a => {
            a.baseFiles = a.baseFiles.map(f => {
                return __pickUpFields(['fileName', 'fileOldName', 'filePath', 'fileSize', 'fileType', 'sort'], f)
            })
            delete a.typeParents
        })

        return apis.checkOtherInfo(data).then(payload.success, payload.error)
    },
    submitContacts ({ commit, state }) {
        let contacts = state.linkpersons.map(c => __pickUpFields(['id', 'fpersonname', 'idCard', 'fworkphone', 'fposition', 'fphone', 'femail', 'remark', 'personType','baseFiles'], c))
        let data = Object.assign({stockId: state.basic.id}, {linkPersons: contacts})
        return apis.checkLinkPersons(data)
    },
    submitServiceas ({ commit, state }) {
        let serviceas = state.serviceas.map(c => __pickUpFields(['id', 'cfprovinceid', 'cfcityid', 'cfremark'], c))
        let data = Object.assign({stockId: state.basic.id}, {serviceas: serviceas})
        return apis.checkServiceas(data)
    },
    submitSpss ({ commit, state }) {
        let spss = state.spss.map(c => __pickUpFields(['id', 'cfservicetypeid', 'cfremak', 'cfcellpeopleid', 'fpersonname', 'serviceaList'], c))
        let data = Object.assign({stockId: state.basic.id}, {spss: spss})
        return apis.checkSpss(data)
    },
    submitManagers ({ commit, state }) {
        let managers = state.managers.map(c => __pickUpFields(['id', 'idCard', 'name', 'officeTel', 'mobile', 'email', 'achievement', 'major', 'grade', 'certificateNo', 'baseFileList'], c))
        let data = Object.assign({stockId: state.basic.id}, {managers: managers})
        return apis.checkManagers(data)
    },
    submitGysfj ({ commit, state }) {
        let gysfjs = state.gysfjs.map(c => __pickUpFields(['fileName', 'fileOldName', 'filePath', 'fileSize', 'fileType', 'sort'], c))
        let data = Object.assign({stockId: state.basic.id}, {gysfj: gysfjs})
        return apis.checkGysfjs(data)
    },
    getBankInfoList ({ commit, state }) {
        let data = {
            stockId: state.basic.id
        }
        return apis.getBankInfo(data).then((res) => {
            if (res.data.result) {
                commit(types.FETCH_BANKINFO, res.data.value)
            } else {
                this.$alert(res.data.message)
            }
        }, err => {
            this.$alert(err)
        })
    },
    addOrEditBankInfo ({ commit }, payload) {
        commit(isNaN(payload.editIndex) ? types.ADD_BANKINFO : types.EDIT_BANKINFO, payload)
    },
    removeBankInfo ({ commit, state }, payload) {
        commit(types.REMOVE_BANKINFO, payload)
    },
    submitBankInfo ({ commit, state }) {
        let bankInfo = state.bankInfo.map(c => __pickUpFields(['id', 'address', 'accountName', 'relationNo', 'name', 'bankNo', 'fparentid', 'bankType'], c))
        return apis.submitBankInfo(bankInfo)
    },

    setIsShowBasic({ commit, state },payload){
        commit(types.SET_IS_SHOW_BASIC, payload)
    },

    setHasYrz({ commit, state },payload){
        commit(types.SET_HAS_YRZ, payload)
    }
}

const mutations = {
    [types.ACCOUNT_FORM] (state, payload) {
        state.account = payload
    },
    [types.REG_STEP] (state, payload) {
        state.regStep = payload
    },
    [types.FETCH_CONTACTS] (state, payload) {
        state.linkpersons = payload
    },
    [types.FETCH_SERVICEAS] (state, payload) {
        state.serviceas = payload
    },
    [types.FETCH_SPSS] (state, payload) {
        state.spss = payload
    },
    [types.FETCH_LinksToSps] (state, payload) {
        state.linkstosps = payload
    },
    [types.FETCH_MANAGERS] (state, payload) {
        state.managers = payload
    },
    [types.FETCH_GYSFJS] (state, payload) {
        state.gysfjs = payload
    },
    [types.ADD_MANAGER] (state, payload) {
        state.managers.push(payload.manager)
    },
    [types.EDIT_MANAGER] (state, payload) {
        let index = payload.editIndex
        delete payload.editIndex
        state.managers.splice(index, 1, payload.manager)
    },
    [types.REMOVE_MANAGER] (state, index) {
        state.managers.splice(index, 1)
    },
    [types.ADD_CONTACT] (state, payload) {
        state.linkpersons.push(payload.contact)
    },
    [types.EDIT_CONTACT] (state, payload) {
        let index = payload.editIndex
        delete payload.editIndex
        state.linkpersons.splice(index, 1, payload.contact)
    },
    [types.REMOVE_CONTACT] (state, index) {
        state.linkpersons.splice(index, 1)
    },
    [types.ADD_SERVICE_AREA] (state, payload) {
        delete payload.editIndex
        state.serviceas.push(payload.area)
    },
    [types.EDIT_SERVICE_AREA] (state, payload) {
        let index = payload.editIndex
        delete payload.editIndex
        state.serviceas.splice(index, 1, payload.area)
    },
    [types.REMOVE_SERVICE_AREA] (state, index) {
        state.serviceas.splice(index, 1)
    },
    [types.ADD_CATEGORY] (state, payload) {
        state.spss.push(payload.category)
    },
    [types.EDIT_CATEGORY] (state, payload) {
        state.spss.splice(payload.editIndex, 1, payload.category)
    },
    [types.REMOVE_CATEGORY] (state, index) {
        state.spss.splice(index, 1)
    },
    [types.ADD_LINKPERSONS] (state) {
        state.regForm.linkpersons = state.linkpersons.slice(0).map(c => {
            delete c.editIndex
            return c
        })
    },
    [types.ADD_SERVICEAS] (state) {
        state.regForm.serviceas = state.serviceas.map(v => {
            let area = Object.assign({}, v)
            delete area.editIndex
            delete area.province
            delete area.city
            return area
        })
    },
    [types.ADD_SPSS] (state) {
        state.regForm.spss = state.spss.map(v => {
            let sp = Object.assign({}, v)
            delete sp.cfservicetypename
            return sp
        })
    },
    [types.REMOVE_SPSS] (state) {
        delete state.regForm.spss
    },
    [types.ADD_SALES] (state, payload) {
        state.other.yearsales.push(payload.yearsale)
    },
    [types.ADD_GYSF] (state, payload) {
        state.gysfjs = payload.gysfj
    },
    [types.EDIT_SALES] (state, payload) {
        state.other.yearsales.splice(payload.editIndex, 1, payload.yearsale)
    },
    [types.REMOVE_SALES] (state, index) {
        state.other.yearsales.splice(index, 1)
    },
    [types.ADD_ACHIEVE] (state, payload) {
        state.other.achievements.push(payload.achievement)
    },
    [types.EDIT_ACHIEVE] (state, payload) {
        state.other.achievements.splice(payload.editIndex, 1, payload.achievement)
    },
    [types.REMOVE_ACHIEVE] (state, index) {
        state.other.achievements.splice(index, 1)
    },
    [types.ADD_APTITUDE] (state, payload) {
        state.other.aptitudefiles.push(payload.aptitude)
    },
    [types.EDIT_APTITUDE] (state, payload) {
        state.other.aptitudefiles.splice(payload.editIndex, 1, payload.aptitude)
    },
    [types.REMOVE_APTITUDE] (state, index) {
        state.other.aptitudefiles.splice(index, 1)
    },
    [types.REMOVE_PASS2] (state) {
        delete state.account.fpassword2
    },
    [types.UPDATE_TAXPAYER_TYPE] (state, payload) {

    },
    [types.UPDATE_COMPANY_TYPE] (state, payload) {
        state.account.fsuppliertypeid = payload
    },
    [types.MAKE_REG_FORM] (state, payload) {
        let account = Object.assign({}, state.account)
        delete account.floginnum
        delete account.fpassword2
        let linkpersons = state.linkpersons.slice(0).map(c => {
            delete c.index
            return c
        })
        let serviceas = state.serviceas.map(v => {
            let area = Object.assign({}, v)
            delete area.province
            delete area.city
            return area
        })
        let spss = state.spss.map(v => {
            let sp = Object.assign({}, v)
            delete sp.cfservicetypename
            delete sp.cfcellpeopleid
            delete sp.farParent
            return sp
        })
        let managers = state.managers
        let yearsales = state.other.yearsales
        let achievements = state.other.achievements.map(a => {
            a.baseFiles = a.baseFiles.map(f => {
                return __pickUpFields(['fileName', 'fileOldName', 'filePath', 'fileSize', 'fileType'], f)
            })
            delete a.farParent
            return a
        })
        let aptitudefiles = state.other.aptitudefiles.map(a => {
            a.baseFiles = a.baseFiles.map(f => {
                return __pickUpFields(['fileName', 'fileOldName', 'filePath', 'fileSize', 'fileType'], f)
            })
            return a
        })
        let gysfj = state.gysfjs.map(a => {
            return __pickUpFields(['fileName', 'fileOldName', 'filePath', 'fileSize', 'fileType', 'sort'], a)
        })
        let bankInfo = state.bankInfo.map(c => __pickUpFields(['id', 'address', 'accountName', 'relationNo', 'name', 'bankNo', 'fparentid', 'bankType'], c))
        state.regForm = {
            ...account,
            linkpersons,
            serviceas,
            spss,
            managers,
            yearsales,
            achievements,
            aptitudefiles,
            gysfj,
            bankInfo
        }
    },
    [types.SUPPLIER_BASIC_FORM] (state, payload) {
        state.basic = payload
    },
    [types.SUPPLIER_USER_INFO] (state, payload) {
        state.user = payload
    },
    [types.FETCH_STOCK_INFO] (state, payload) {
        state.basic = payload.supplierStockInfo
        state.user = payload.supplierUserInfo
    },
    [types.FETCH_OTHER_INFO] (state, payload) {
        __addFileName(payload.achievements)
        __addFileName(payload.aptitudefiles)
        state.other = payload
    },
    [types.FETCH_AUDIT_INFO] (state, payload) {
        state.audits = payload
    },
    // for bankinfo
    [types.FETCH_BANKINFO] (state, payload) {
        state.bankInfo = payload
    },
    [types.ADD_BANKINFO] (state, payload) {
        state.bankInfo.push(payload.bankInfo)
    },
    [types.EDIT_BANKINFO] (state, payload) {
        let index = payload.editIndex
        delete payload.editIndex
        state.bankInfo.splice(index, 1, payload.bankInfo)
    },
    [types.REMOVE_BANKINFO] (state, index) {
        state.bankInfo.splice(index, 1)
    },
    [types.SET_IS_SHOW_BASIC] (state,val){
        state.isShowBasic = val;
    },
    [types.SET_HAS_YRZ] (state,val){
        state.hasYrz = val;
    }
}
function __addFileName (data) {
    data.forEach(d => {
        d.baseFiles.forEach(f => {
            f.name = f.fileOldName || f.fileName
        })
    })
}
function __pickUpFields (fields, obj) {
    let newObj = {}
    fields.forEach(f => {
        newObj[f] = obj[f]
    })
    return newObj
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/supplier.js